<template>
  <form ref="formRequestToken" @submit.prevent="submitForm" class="form__request-token">
    <v-layout align-center row wrap>
      <v-flex md6>
        <div class="pr-2">
          <label for="name">*{{ $t(`${namespace}.nameInput`) }}</label>
          <v-text-field
            v-model="requestTokenForm.name"
            type="text"
            name="name"
            :placeholder="$t(`${namespace}.namePlaceholder`)"
            :disabled="sending"
            v-validate="{ required: true }"
            :error-messages="errors.collect($t(`${namespace}.nameInput`))"
            :data-vv-name="$t(`${namespace}.nameInput`)"
            required
            flat
            outline
            solo
          />
        </div>
      </v-flex>

      <v-flex md6>
        <div class="pl-2">
          <label for="email">*{{ $t(`${namespace}.emailInput`) }}</label>
          <v-text-field
            v-model="requestTokenForm.email"
            type="email"
            name="email"
            :placeholder="$t(`${namespace}.emailPlaceholder`)"
            :disabled="sending"
            v-validate="{ required: true, email: true }"
            :error-messages="errors.collect($t(`${namespace}.emailInput`))"
            :data-vv-name="$t(`${namespace}.emailInput`)"
            required
            flat
            outline
            solo
          />
        </div>
      </v-flex>
      <v-flex xs12 mb-2>
        <div>
          <label>*{{ $t(`${namespace}.isDocUsefulInput`) }}</label>
          <v-radio-group
            class="isDocUsefulGroup"
            v-model="requestTokenForm.isDocUseful"
            name="isDocUseful"
            :disabled="sending"
            v-validate="{ required: true }"
            :error-messages="errors.collect($t(`${namespace}.isDocUsefulInput`))"
            :data-vv-name="$t(`${namespace}.isDocUsefulInput`)"
            row
            required
          >
            <v-radio :label="$t(`Common.yes`)" :value="true"></v-radio>
            <v-radio :label="$t(`Common.no`)" :value="false"></v-radio>
          </v-radio-group>
        </div>
      </v-flex>
      <v-flex xs12>
        <div>
          <label>*{{ $t(`${namespace}.apiVerificationInput`) }}</label>
          <v-text-field
            v-model="requestTokenForm.apiVerification"
            v-validate="{ required: true }"
            :placeholder="$t(`${namespace}.apiVerificationPlaceholder`)"
            :disabled="sending"
            :error-messages="errors.collect($t(`${namespace}.apiVerificationInput`))"
            :data-vv-name="$t(`${namespace}.apiVerificationInput`)"
            flat
            outline
            solo
            required
          />
        </div>
      </v-flex>
      <v-flex xs12>
        <div>
          <label for="justification">*{{ $t(`${namespace}.justificationInput`) }}</label>
          <v-textarea
            name="justification"
            v-model="requestTokenForm.justification"
            :placeholder="$t(`${namespace}.justificationPlaceholder`)"
            :disabled="sending"
            v-validate="{ required: true }"
            :error-messages="errors.collect($t(`${namespace}.justificationInput`))"
            :data-vv-name="$t(`${namespace}.justificationInput`)"
            counter="500"
            maxlength="500"
            required
            flat
            outline
            solo
          >
          </v-textarea>
        </div>
      </v-flex>
      <v-flex xs12 class="page__button">
        <v-btn round depressed color="accent" type="submit" :loading="sending">
          {{ $t(`${namespace}.btnRequest`) }}
        </v-btn>
      </v-flex>
    </v-layout>
  </form>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Form',
  data () {
    return {
      namespace: 'Views.TokenRequestPage',
      requestTokenForm: {
        name: '',
        email: '',
        justification: '',
        apiVerification: '',
        isDocUseful: undefined
      },
      sending: false
    }
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    })
  },
  methods: {
    ...mapActions({
      infoAlert: 'snackbarAlert/info',
      errorAlert: 'snackbarAlert/error',
      successAlert: 'snackbarAlert/success'
    }),

    async submitForm () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) return
      try {
        const data = this.requestTokenForm
        const companyId = this.company ? this.company.id : null

        if (!companyId) {
          this.infoAlert(this.$t(`${this.namespace}.noCompanySelected`))
          return
        }
        this.sending = true

        await this.$apiService.requestApiToken(companyId, data)

        setTimeout(() => {
          this.sending = false
          this.resetForm()
          this.$emit('submittedForm')
          this.successAlert(this.$t(`${this.namespace}.requestSuccess`))
        }, 3000)
      } catch (error) {
        this.sending = false
        this.errorAlert(this.$t(`${this.namespace}.requestError`))
        console.log(error)
      }
    },

    resetForm () {
      this.requestTokenForm = {
        name: '',
        email: '',
        justification: '',
        apiVerification: '',
        isDocUseful: undefined
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form__request-token {
  padding: 24px;
}
.page__button {
  display: flex;
  justify-content: center;
}
</style>
